import ToolLandingTemplate from '../../components/landing/ToolLandingTemplate';
import { LIVE_TOOLS } from '../../data/tools';
import { qrCodeLanding } from '../../content/qrCodeContent';

const tool = LIVE_TOOLS.find((t) => t.id === 'qr-code-generator');

export default function QrCodeGeneratorLanding() {
  return <ToolLandingTemplate tool={tool} {...qrCodeLanding} />;
}
